import { createAction, props } from '@ngrx/store';

export const setZIndex = createAction('[Loading] Set ZIndex', props<{ zIndex: number }>());
export const setProgress = createAction('[Loading] Set Progress', props<{ progress: number }>());
